const images = {
    mamontLogo: '/assets/test_images/mamont-logo.png',
    mamontLogoWhite: '/assets/homepage_images/mamont_logo_white.png',
    homepageslider1: '/assets/homepage_images/homepageslider1.jpg',
    homepageslider2: '/assets/homepage_images/homepageslider2.jpg',
    homepageslider3: '/assets/homepage_images/homepageslider3.jpg',
    homepageAnimation: '/assets/homepage_images/homepageAnimation.jpg',
    homepageWorker: '/assets/homepage_images/homepage-worker.png',
    logoPartner1: '/assets/homepage_images/logo-5.png',
    logoPartner2: '/assets/homepage_images/mtm-logo.png',
    logoPartner3: '/assets/homepage_images/Paree-logo.png',
    logoPartner4: '/assets/homepage_images/Rellium-Logo.png',
    logoPartner5: '/assets/homepage_images/RS_solutions_logo.png',
    image1: '/assets/test_images/image1.jpg',
    aboutUsAnimation: '/assets/about_us_images/about_us_animation.jpg',
    aboutUsWorkers: '/assets/about_us_images/about_us_workers.jpg',
    mamontPruzanjeKablova: '/assets/mamont_images/mamont_pruzanje_kablova.jpg',
    mamontTesting: '/assets/mamont_images/mamont_testing.jpg',
    mamontTeam1: '/assets/mamont_images/mamont-team1.jpg',
    mamontTeam2: '/assets/mamont_images/mamont-team2.jpg',
    mamont2: '/assets/mamont_images/mamont2.webp',
    mamont3: '/assets/mamont_images/mamont3.jpg',
    mamont4: '/assets/mamont_images/mamont4.webp',
    mamont5: '/assets/mamont_images/mamont5.jpg',
    mamont6: '/assets/mamont_images/mamont6.jpg',
    mamont7: '/assets/mamont_images/mamont7.jpg',
    mamont8: '/assets/mamont_images/mamont8.webp',
    mamont9: '/assets/mamont_images/mamont9.jpg',
    mamont10: '/assets/mamont_images/mamont10.webp',
    mamont11: '/assets/mamont_images/mamont11.jpg',
    mamont12: '/assets/mamont_images/mamont12.webp',
    mamont13: '/assets/mamont_images/mamont13.jpg',
    mamont14: '/assets/mamont_images/mamont14.jpg',
    mamont15: '/assets/mamont_images/mamont15.webp',
    mamont16: '/assets/mamont_images/mamont16.webp',
    mamont17: '/assets/mamont_images/mamont17.jpg',
    mamont19: '/assets/mamont_images/mamont19.webp',
    mamont20: '/assets/mamont_images/mamont20.webp',
};

export default images;